import { useState } from 'react'

import { comicPanelToLightboxItems, lightboxIndexForCandidate } from '../../lib/comicPanelLightbox'
import type { ComicPanel } from '../../lib/comicTypes'
import { ImageLightbox } from '../ImageLightbox'
import { ThemeModal } from '../modal'
import { ComicCandidateMediaTile } from './ComicCandidateMediaTile'

type Props = {
  open: boolean
  angular: boolean
  panel: ComicPanel | null
  panelAspectClass: string
  onClose: () => void
  onSelect: (candidateId: string) => void
  onRemove?: (candidateId: string) => void
}

export function ComicPanelCandidatesModal({
  open,
  angular,
  panel,
  panelAspectClass,
  onClose,
  onSelect,
  onRemove,
}: Props) {
  const candidates = panel?.candidates ?? []
  const selectedId = panel?.selectedCandidateId
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null)
  const lightboxItems = comicPanelToLightboxItems(panel)

  const openPreview = (candidateId: string) => {
    setLightboxIndex(lightboxIndexForCandidate(panel, candidateId))
  }

  return (
    <>
      <ThemeModal
        open={open}
        onClose={onClose}
        title={panel ? `分镜 #${panel.order} · 候选成图` : '候选成图'}
        angular={angular}
        size="lg"
        bodyClassName="px-4 py-4 sm:px-5 sm:py-5"
      >
        {candidates.length === 0 ? null : (
          <div className="scroll-region max-h-[min(70vh,32rem)] overflow-y-auto pe-1">
            <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {candidates.map((c) => (
                <ComicCandidateMediaTile
                  key={c.id}
                  angular={angular}
                  imageUrl={c.imageUrl}
                  selected={c.id === selectedId}
                  aspectClass={panelAspectClass}
                  onPreview={() => openPreview(c.id)}
                  onSelect={() => onSelect(c.id)}
                  selectLabel="选为定稿"
                  selectedLabel="当前定稿"
                  onRemove={onRemove ? () => onRemove(c.id) : undefined}
                />
              ))}
            </ul>
          </div>
        )}
      </ThemeModal>
      <ImageLightbox
        open={lightboxIndex != null && lightboxItems.length > 0}
        items={lightboxItems}
        index={lightboxIndex ?? 0}
        angular={angular}
        onIndexChange={setLightboxIndex}
        onClose={() => setLightboxIndex(null)}
      />
    </>
  )
}
